import styles from './index.module.css'
import SearchImage from './components/SearchImage'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'


function ImageSearch() {
    let has_login = useSelector(state => state.get('login').get('has_login'))

    const renderContent = () => {
        if (!has_login) {
            return <Redirect to="/" />
        } else {
            return (
                <div className={styles.main}>
                    <SearchImage />
                </div>
            )
        }
    }

    return (
        renderContent()
    )
}

export default ImageSearch